// extracted by mini-css-extract-plugin
module.exports = {"image":"parallax_image__BiBRE","content":"parallax_content__5TGHk","wrapper":"parallax_wrapper__DvjpP"};